import React, { useState, useRef, useEffect } from "react";
import classNames from "classnames";

export default function TreeCheckboxDropdown({
  data = [],
  onChange = () => {},
  label = "Select Categories",
  labelClasses = "",
  required = false,
  selected: selectedProp = [],
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);

  useEffect(() => {
    setSelected(selectedProp || []);
  }, [selectedProp]);

  const handleSelect = (id) => {
    const updated = selected.includes(id)
      ? selected.filter((item) => item !== id)
      : [...selected, id];
    setSelected(updated);
    onChange(updated);
  };

  const handleClickOutside = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const filterData = (items) => {
    return items
      .map((item) => {
        const subItems = item.subcategory || item.subCategory || [];
        const subMatches = filterData(subItems);
        const isMatch = item.name
          .toLowerCase()
          .includes(searchTerm.toLowerCase());
        if (isMatch || subMatches.length > 0) {
          return {
            ...item,
            subCategory: subMatches,
          };
        }
        return null;
      })
      .filter(Boolean);
  };

  const renderItems = (items = [], level = 0) => {
    return items.map((item) => {
      const children = item.subcategory || item.subCategory || [];
      return (
        <div key={item._id}>
          <div
            className="flex items-center py-1 px-4 hover:bg-gray-50 cursor-pointer"
            style={{ paddingLeft: `${level * 16 + 12}px` }}
          >
            <input
              type="checkbox"
              checked={selected.includes(item._id)}
              onChange={() => handleSelect(item._id)}
              className="w-4 h-4"
            />
            <label className="ml-2 text-sm text-gray-800">{item.name}</label>
          </div>
          {children.length > 0 && renderItems(children, level + 1)}
        </div>
      );
    });
  };

  const filteredData = searchTerm ? filterData(data) : data;

  return (
    <div className="w-full relative space-y-1" ref={dropdownRef}>
      {/* Label Section */}
      {label && (
        <div
          className={classNames(
            "text-xs font-medium text-shades-07 relative",
            labelClasses
          )}
        >
          {label}
          {required && (
            <span className="text-[8px] text-red-500 ml-0.5 absolute top-[-2px]">
              <i className="fa-solid fa-asterisk"></i>
            </span>
          )}
        </div>
      )}

      {/* Dropdown Button */}
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="w-full px-4 py-2 bg-white border rounded shadow-sm flex justify-between items-center"
      >
        <span>
          {label} ({selected.length})
        </span>
        <svg
          className={`w-5 h-5 transform transition-transform ${
            isOpen ? "rotate-180" : "rotate-0"
          }`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            d="M19 9l-7 7-7-7"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <div className="absolute z-10 mt-2 w-full bg-white border rounded shadow-lg max-h-64 overflow-y-auto">
          <div className="p-2 border-b">
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search"
              className="w-full px-2 py-1 border rounded text-sm"
            />
          </div>
          <div>{renderItems(filteredData)}</div>
        </div>
      )}
    </div>
  );
}
